import useApi, { GET_DOCUMENT } from 'hooks/useApi';
import { useEffect } from 'react';

export default ({ id }) => {
  const [state, sendRequest] = useApi();
  const { data, isLoading } = state;

  useEffect(() => {
    if (!data || isLoading) return;
    const { documentLink } = data;
    window.open(documentLink, '_blank');
  }, [data, isLoading]);

  const fetchPdf = () => {
    const params = GET_DOCUMENT({ id });
    sendRequest(params);
  };

  return [isLoading, fetchPdf];
};
